// All content for Aravi Eco Homes — A Nature Crafted Community
// Project: Ibrahimpatnam, Telangana (near Hyderabad). HMDA Limits.

export const PROJECT = {
  name: 'Aravi Eco Homes',
  tagline: 'A Nature Crafted Community',
  location: 'Ibrahimpatnam · Telangana · 17.089, 78.743',
  mapsUrl: 'https://maps.app.goo.gl/bweLKQnrMbfNdGjdA',
  address: 'Flat No. 303, Cyber Residency, Indra Nagar, Gachibowli, Serilingampally, K.V. Rangareddy — 500032, Telangana',
  phone: '+91 94919 29527',
  phoneRaw: '+919491929527',
  phoneAlt: '+91 94949 49527',
  phoneAltRaw: '+919494949527',
  email: 'sales@araviecohomes.com',
  extent: '25 acres · 110 villas',
};

export const HERO_SLIDES = [
  {
    image: 'https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmb3Jlc3QlMjBob21lJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
    eyebrow: 'Discovered. Then Planned.',
    title: 'A Nature\nCrafted Community.',
    subtitle: '25 acres, 110 villas — shaped around 1,100 acres of the Osmania Geological Observatory belt (forest), not the other way around.',
    location: 'Ibrahimpatnam · Telangana',
  },
  {
    image: 'https://images.unsplash.com/photo-1767677505638-38c958c3e794?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxnbGFzcyUyMGhvdXNlJTIwbmF0dXJlJTIwZm9yZXN0JTIwcmV0cmVhdHxlbnwwfHx8fDE3ODI3MzEyMzZ8MA&ixlib=rb-4.1.0&q=85',
    eyebrow: 'HMDA Limits · Legally Clear',
    title: 'Total Hill View.\n75% Oxygen.',
    subtitle: 'A double-road, 15 minutes from ORR Exit. Wrapped by a Miyawaki forest and quiet valleys.',
    location: 'ORR Exit · 15 min',
  },
  {
    image: 'https://images.unsplash.com/photo-1757359056339-22968344cce6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBmb3Jlc3QlMjBob21lJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
    eyebrow: 'Two Homes. One Land.',
    title: 'Customised\nG+1 Homes.',
    subtitle: '605 sq yards or 1,210 sq yards. A finished G+1 home included — land at ₹10,999 per sq yard.',
    location: 'From ₹66.54 L',
  },
];

// The "Residences" data is repurposed as the two real home configurations Aravi offers.
export const RESIDENCES = [
  {
    id: 1,
    slug: 'the-605',
    name: 'The 605',
    location: 'Aravi · Ibrahimpatnam, Telangana',
    region: 'The 605',
    tagline: '605 sq yards of land with a finished 600 sqft G+1 home — expandable to 1,500 or 2,000 sqft on your terms.',
    image: 'https://images.unsplash.com/photo-1698994705178-d244d73ea573?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmb3Jlc3QlMjBob21lJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1698994705178-d244d73ea573?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmb3Jlc3QlMjBob21lJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmb3Jlc3QlMjBob21lJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1541963463532-d68292c34b19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxuYXR1cmUlMjBsaWZlc3R5bGUlMjByZWFkaW5nJTIwZm9yZXN0fGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
    ],
    beds: 'G+1',
    baths: 'Custom',
    acres: '605 sq yd',
    status: 'Open for Booking',
    priceFrom: '₹ 66.54 L',
    priceNote: 'Includes 600 sqft G+1 home',
    expandable: 'Land priced at ₹10,999 per sq yard · Expandable up to 1,500–2,000 sqft',
    description: 'A 605-square-yard plot at Aravi, with a 600-square-foot Ground+1 home finished and handed over by the developer. Customise the layout and expand the built area up to 1,500 or 2,000 square feet at a clear, published rate of ₹10,999 per square foot. Set within a community where every plot opens to plantings, a hill view and the wider 1,100-acre observatory belt.',
  },
  {
    id: 2,
    slug: 'the-1210',
    name: 'The 1210',
    location: 'Aravi · Ibrahimpatnam, Telangana',
    region: 'The 1210',
    tagline: '1,210 sq yards of land with a finished 1,000 sqft G+1 home — expandable to 2,000 or 2,500 sqft on your terms.',
    image: 'https://images.unsplash.com/photo-1760014847137-366faca53d74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxnbGFzcyUyMGhvdXNlJTIwbmF0dXJlJTIwZm9yZXN0JTIwcmV0cmVhdHxlbnwwfHx8fDE3ODI3MzEyMzZ8MA&ixlib=rb-4.1.0&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1760014847137-366faca53d74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxnbGFzcyUyMGhvdXNlJTIwbmF0dXJlJTIwZm9yZXN0JTIwcmV0cmVhdHxlbnwwfHx8fDE3ODI3MzEyMzZ8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1767677505638-38c958c3e794?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxnbGFzcyUyMGhvdXNlJTIwbmF0dXJlJTIwZm9yZXN0JTIwcmV0cmVhdHxlbnwwfHx8fDE3ODI3MzEyMzZ8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1778037236171-47f59f5e16bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxuYXR1cmUlMjBsaWZlc3R5bGUlMjByZWFkaW5nJTIwZm9yZXN0fGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
    ],
    beds: 'G+1',
    baths: 'Custom',
    acres: '1,210 sq yd',
    status: 'Limited Inventory',
    priceFrom: '₹ 1.33 Cr',
    priceNote: 'Includes 1,000 sqft G+1 home',
    expandable: 'Land priced at ₹10,999 per sq yard · Expandable up to 2,000–2,500 sqft',
    description: 'A 1,210-square-yard plot — the larger Aravi configuration — with a 1,000-square-foot Ground+1 home included. Suited for households who want a deeper garden, an extended ground floor, or to size up to 2,000 or 2,500 square feet on a single, transparent rate.',
  },
];

// The four community covenants — now reflecting the real Aravi promises
export const SUSTAINABILITY = [
  {
    icon: 'TreePine',
    title: 'Miyawaki Forest Belt',
    desc: 'A dense, native Miyawaki forest wraps the community — fast-growing, biodiverse, and a working oxygen reserve.',
  },
  {
    icon: 'Sun',
    title: 'Solar + Rainwater',
    desc: 'Solar arrays on common infrastructure, rainwater harvesting across every street, retention ponds and a rain garden.',
  },
  {
    icon: 'Sprout',
    title: 'A Natural Farm',
    desc: 'A working natural farm on site — chemical-free produce, native seed stock, and a farm store at the community gate.',
  },
  {
    icon: 'ShieldCheck',
    title: 'HMDA Limits · Legally Clear',
    desc: 'Every plot falls within HMDA Limits, with transparent work progress and clear titles — the documents speak for themselves.',
  },
];

export const LIFESTYLE = [
  {
    title: 'Trekking, Cycling & Walking Trails',
    image: 'https://images.unsplash.com/photo-1541963463532-d68292c34b19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxuYXR1cmUlMjBsaWZlc3R5bGUlMjByZWFkaW5nJTIwZm9yZXN0fGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
  },
  {
    title: 'Wellness Lounge & Yoga Deck',
    image: 'https://images.unsplash.com/photo-1778037236171-47f59f5e16bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxuYXR1cmUlMjBsaWZlc3R5bGUlMjByZWFkaW5nJTIwZm9yZXN0fGVufDB8fHx8MTc4MjczMTIzNnww&ixlib=rb-4.1.0&q=85',
  },
];

export const TESTIMONIALS = [
  {
    quote: 'We came looking for a plot. We left having found a community. The Miyawaki belt, the hill view, the quiet — it didn\'t feel like real estate. It felt like a place that already existed.',
    name: 'Anika & Rohan Mehta',
    role: 'Owners · The 605',
    avatar: 'https://images.unsplash.com/photo-1759354087621-37d6dd79886a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMG5hdHVyZSUyMG5ldXRyYWwlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjczMTIzNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    quote: 'The HMDA approval was the first thing we asked for. The transparency of the work-progress updates is what made us sign.',
    name: 'Devika Iyer',
    role: 'Owner · The 1210',
    avatar: 'https://images.unsplash.com/photo-1759873821340-24189bde9922?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMG5hdHVyZSUyMG5ldXRyYWwlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjczMTIzNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    quote: 'Fifteen minutes from ORR Exit, but our mornings sound like a forest. The kids walk barefoot. That\'s the part you can\'t price.',
    name: 'Karthik Subramanian',
    role: 'Owner · The 1210',
    avatar: 'https://images.unsplash.com/photo-1759354087621-37d6dd79886a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMG5hdHVyZSUyMG5ldXRyYWwlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjczMTIzNXww&ixlib=rb-4.1.0&q=85',
  },
];

// Marquee strip: real selling points
export const LANDSCAPES = [
  'Miyawaki Forest',
  'Natural Farm',
  'Farm Store',
  'Koneru',
  'Biopool',
  'Amphitheatre',
  'Yoga Deck',
  'Hill View',
  'Cycling Track',
  'Rain Garden',
];
